module.exports = __webpack_public_path__ + "static/media/07.9be89d8d.jpg";